import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {CardItem, CardItemStyle} from "../../../../common/CardItem";
import {styleRuleInherit} from "../../../../../stem-core/src/decorators/Style";


class WidgetCardItemStyle extends CardItemStyle {
    @styleRuleInherit
    cardNumber = {
        color: this.themeProps.WALLET_COLOR,
        marginLeft: 63,
    };

    @styleRuleInherit
    expiryDate = {
        color: this.themeProps.WALLET_CARD_EXPIRY_DATE,
    };
}

@registerStyle(WidgetCardItemStyle)
export class WidgetCardItem extends CardItem {}
